'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _keyOrIndexToProperty = require('./keyOrIndexToProperty');

var _keyOrIndexToProperty2 = _interopRequireDefault(_keyOrIndexToProperty);

var _keyOrIndexToKey = require('./keyOrIndexToKey');

var _keyOrIndexToKey2 = _interopRequireDefault(_keyOrIndexToKey);

var _updateMeta = require('./updateMeta');

var _updateMeta2 = _interopRequireDefault(_updateMeta);

var _prepareChildKeys = require('./prepareChildKeys');

var _prepareChildKeys2 = _interopRequireDefault(_prepareChildKeys);

var _getIn = require('unmutable/lib/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _pipeWith = require('unmutable/lib/util/pipeWith');

var _pipeWith2 = _interopRequireDefault(_pipeWith);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (key, notFoundValue) {
    return function (parcelData) {

        parcelData = (0, _prepareChildKeys2.default)()(parcelData);
        var property = (0, _keyOrIndexToProperty2.default)(key)(parcelData);
        var stringKey = (0, _keyOrIndexToKey2.default)(key)(parcelData);

        return (0, _updateMeta2.default)()((0, _extends3.default)({
            value: (0, _getIn2.default)(['value', property], notFoundValue)(parcelData)
        }, (0, _pipeWith2.default)(parcelData, (0, _getIn2.default)(['child', property], { key: stringKey }))));
    };
};


//////////////////
// WEBPACK FOOTER
// ./~/parcels/lib/parcelData/get.js
// module id = 239
// module chunks = 35783957827783